module.exports = __webpack_public_path__ + "img/shipo-icon-delete.d259aa25.svg";